import { css, createVariantMap } from '@kui-shared/styles';

const AspectRatios = ['1-1', '1-2', '10-16', '16-10', '16-9', '2-1', '2-3', '21-9', '3-2', '3-4', '3-5', '4-3', '4-5', '5-3', '5-4', '5-7', '7-5', '9-16', '9-21'];

const ImageStyle = css({
  // Reset
  overflow: 'hidden',
  // Layout
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  variants: {
    aspectRatio: createVariantMap(AspectRatios, ratio => ({
      aspectRatio: ratio.replace('-', '/')
    }))
  }
});

/**
 * TestIDs
 */
const ImageTestIDs = {
  Image: 'kui-image'
};
/**
 * Defaults
 */
const ImageDefaults = {
  css: {},
  aspectRatio: '1-1'
};

export { AspectRatios, ImageDefaults, ImageStyle, ImageTestIDs };
